import { create } from 'zustand';
import type { CapabilityId } from '@/auth/scopes';

/**
 * Light session state (§7 Zustand). Tracks which capability modules the admin has
 * explicitly consented to this session — the UI unlocks features incrementally (§4).
 * No tokens or tenant data are stored here.
 */
interface SessionState {
  consented: Set<CapabilityId>;
  grantConsent: (cap: CapabilityId) => void;
  hasConsent: (cap: CapabilityId) => boolean;
  reset: () => void;
}

export const useSession = create<SessionState>((set, get) => ({
  consented: new Set<CapabilityId>(),
  grantConsent: (cap) =>
    set((s) => ({ consented: new Set(s.consented).add(cap) })),
  hasConsent: (cap) => get().consented.has(cap),
  reset: () => set({ consented: new Set<CapabilityId>() }),
}));
